export const rewriteStoryblokAssetUrl = (url: string) =>
  url.replace(
    'https://a.storyblok.com',
    'https://s3.amazonaws.com/a.storyblok.com'
  );
